import React from 'react'
import { Carousel, Col, Container, Row } from 'react-bootstrap'

const ServicesHeading = ({title, subtitle, classToAdd, isnew, bgImages, subtitleStyle, topPadding, revealOnScroll}) => {
    const [textVisible, setTextVisible] = React.useState(!revealOnScroll)

    React.useEffect(() => {
        if (!revealOnScroll) return

        const handleScroll = () => {
            setTextVisible(window.scrollY > 40)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [revealOnScroll])

    const containerStyle = {
        padding: isnew ? "200px 0 100px 0" : `${topPadding || 200}px 0`,
        minHeight: "80vh", 
        position: "relative",
        overflow: "hidden",
    }

    return (
        <div className={"bg-gradient services-hero " + classToAdd} style={containerStyle}>
            {bgImages && bgImages.length > 0 && (
                <>
                    <Carousel
                        controls={false}
                        indicators={false}
                        interval={4000}
                        fade
                        className="services-heading-carousel"
                    >
                        {bgImages.map((img, idx) => (
                            <Carousel.Item key={idx}>
                                <img src={img} className="services-heading-carousel-img" alt="" />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                    <div 
                        className="services-heading-overlay"
                        style={{
                            opacity: textVisible ? 1 : 0,
                            transition: "opacity 0.5s ease",
                        }}
                    ></div>
                </>
            )}
            <Container
                className={revealOnScroll ? "services-heading-text-reveal" : ""}
                style={{
                    position: "relative",
                    zIndex: 2,
                    paddingTop: "80px",
                    opacity: textVisible ? 1 : 0,
                    transform: textVisible ? "translateY(0px)" : "translateY(20px)",
                    transition: "opacity 0.5s ease, transform 0.5s ease",
                }}
            >
                <Row>
                    <Col>
                        <h5 className="white blue-bg bold px-3 py-1" style={{width:"max-content", ...subtitleStyle}}>{" "}{subtitle}</h5>
                        <h1 className="white" style={{maxWidth: "990px"}}>{title}</h1>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ServicesHeading